const sassRouter = {
  path: 'saas',
  name: 'saas',
  component: { render: h => h('router-view') },
  children: [
    {
      path: 'user-buy',
      name: 'user-buy',
      component: () => import('views/sass/user-buy'),
    },
    {
      path: 'user-score-details',
      name: 'user-score-details',
      meta: '明细',
      component: () => import('views/sass/user-score/user-score-details'),
    },
    {
      path: 'sass-score-detail',
      name: 'sass-score-detail',
      meta: '详情页',
      component: () => import('views/sass/user-score/sass-score-detail'),
    },
    {
      path: 'user-score',
      name: 'user-score',
      component: () => import('views/sass/user-score'),
    },
  ],
}

export default sassRouter
